import { Component } from "react";

// Lightweight, behavior-neutral error boundary: renders children normally and
// only shows a graceful fallback if a descendant throws during render.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Render error caught by ErrorBoundary:", error, info);
    try { window.posthog?.capture?.("app_render_error", { message: String(error?.message || error) }); } catch (e) {}
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          background: "#111E2B", color: "#F5F0E8", fontFamily: "'EB Garamond', Georgia, serif",
          padding: "32px", textAlign: "center",
        }}
      >
        <div style={{ maxWidth: "480px" }}>
          <div style={{ fontFamily: "'Jost', sans-serif", letterSpacing: ".18em", textTransform: "uppercase", fontSize: "12px", color: "#C9963A", marginBottom: "16px" }}>
            Liturgical Intelligence™
          </div>
          <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: "38px", margin: "0 0 14px" }}>
            Something went wrong.
          </h1>
          <p style={{ color: "#cdc3ab", fontSize: "17px", lineHeight: 1.6, margin: "0 0 28px" }}>
            We hit an unexpected error. Please refresh the page or return home — your information is safe.
          </p>
          <a
            href="/"
            data-testid="error-boundary-home"
            style={{
              display: "inline-block", background: "#C9963A", color: "#111E2B", textDecoration: "none",
              padding: "14px 30px", fontFamily: "'Jost', sans-serif", fontSize: "13px",
              letterSpacing: ".12em", textTransform: "uppercase", fontWeight: 600,
            }}
          >
            Return Home
          </a>
        </div>
      </div>
    );
  }
}
